/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_LabelInputs */

const en_follow_label = /** @type {(inputs: Follow_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow`)
};

const es_follow_label = /** @type {(inputs: Follow_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguir`)
};

const fr_follow_label = /** @type {(inputs: Follow_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivre`)
};

const de_follow_label = /** @type {(inputs: Follow_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folgen`)
};

const id_follow_label = /** @type {(inputs: Follow_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikuti`)
};

/** @type {(inputs: Follow_LabelInputs) => LocalizedString} */
const ja_follow_label = en_follow_label;

/** @type {(inputs: Follow_LabelInputs) => LocalizedString} */
const zh_follow_label = en_follow_label;

/** @type {(inputs: Follow_LabelInputs) => LocalizedString} */
const ar_follow_label = en_follow_label;

/** @type {(inputs: Follow_LabelInputs) => LocalizedString} */
const it_follow_label = en_follow_label;

/** @type {(inputs: Follow_LabelInputs) => LocalizedString} */
const ru_follow_label = en_follow_label;

/** @type {(inputs: Follow_LabelInputs) => LocalizedString} */
const pt_follow_label = en_follow_label;

/** @type {(inputs: Follow_LabelInputs) => LocalizedString} */
const ko_follow_label = en_follow_label;

/**
* | output |
* | --- |
* | "Follow" |
*
* @param {Follow_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_label = /** @type {((inputs?: Follow_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_label(inputs)
	if (locale === "es") return es_follow_label(inputs)
	if (locale === "fr") return fr_follow_label(inputs)
	if (locale === "de") return de_follow_label(inputs)
	if (locale === "ja") return ja_follow_label(inputs)
	if (locale === "zh") return zh_follow_label(inputs)
	if (locale === "ar") return ar_follow_label(inputs)
	if (locale === "id") return id_follow_label(inputs)
	if (locale === "it") return it_follow_label(inputs)
	if (locale === "ru") return ru_follow_label(inputs)
	if (locale === "pt") return pt_follow_label(inputs)
	return ko_follow_label(inputs)
});